require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.accessibilityProps = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/MaterialCommunityIcon.tsx";
var MaterialCommunityIcons;

try {
  MaterialCommunityIcons = require("@expo/vector-icons/MaterialCommunityIcons")["default"];
} catch (e) {
  if (global.__expo && global.__expo.Icon && global.__expo.Icon.MaterialCommunityIcons) {
    MaterialCommunityIcons = global.__expo.Icon.MaterialCommunityIcons;
  } else {
    var isErrorLogged = false;

    MaterialCommunityIcons = function MaterialCommunityIcons(_ref) {
      var name = _ref.name,
          color = _ref.color,
          size = _ref.size,
          rest = (0, _objectWithoutProperties2["default"])(_ref, ["name", "color", "size"]);

      if (!isErrorLogged) {
        if (!/(Cannot find module|Module not found|Cannot resolve module)/.test(e.message)) {
          console.error(e);
        }

        console.warn("Tried to use the icon '".concat(name, "' in a component from 'react-native-paper', but 'react-native-vector-icons' could not be loaded."), "To remove this warning, try installing 'react-native-vector-icons' or use another method to specify icon: https://callstack.github.io/react-native-paper/icons.html.");
        isErrorLogged = true;
      }

      return React.createElement(_reactNative.Text, (0, _extends2["default"])({}, rest, {
        style: [styles.icon, {
          color: color,
          fontSize: size
        }],
        pointerEvents: "none",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 56
        }
      }), "\u25A1");
    };
  }
}

var accessibilityProps = _reactNative.Platform.OS === 'web' ? {
  role: 'img',
  focusable: false
} : {
  accessibilityElementsHidden: true,
  importantForAccessibility: 'no-hide-descendants'
};
exports.accessibilityProps = accessibilityProps;

var defaultIcon = function defaultIcon(_ref2) {
  var name = _ref2.name,
      color = _ref2.color,
      size = _ref2.size,
      direction = _ref2.direction,
      allowFontScaling = _ref2.allowFontScaling;
  return React.createElement(MaterialCommunityIcons, (0, _extends2["default"])({
    allowFontScaling: allowFontScaling,
    name: name,
    color: color,
    size: size,
    style: [{
      transform: [{
        scaleX: direction === 'rtl' ? -1 : 1
      }]
    }, styles.icon],
    pointerEvents: "none"
  }, accessibilityProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87
    }
  }));
};

var styles = _reactNative.StyleSheet.create({
  icon: {
    backgroundColor: 'transparent'
  }
});

var _default = defaultIcon;
exports["default"] = _default;